export const Logout = (navigation: any) => {
  localStorage.clear();
  navigation("/");
  return window.location.reload();
};
